import { useMemo, useEffect, useRef } from "react";
import debounce from "lodash/debounce";

export const useDebounce = (callback, delay = 300) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedFn = useMemo(() => {
    const fn = debounce((...args) => {
      if (callbackRef.current) {
        callbackRef.current(...args);
      }
    }, delay);

    return fn;
  }, [delay]);

  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  return debouncedFn;
};